import { useAuthDependencies } from '@/composables/api/auth'
import { defineStore } from 'pinia'
import { useActorStore } from './actor'

type SubscriptionState = {
  subscriptions: any[]
  subscriberGroups: any[]
  switchingActor: boolean
  loading: boolean
}

export const useSubscriptionStore = defineStore('subscription', {
  state: (): SubscriptionState => {
    return {
      subscriptions: [],
      subscriberGroups: [],
      switchingActor: false,
      loading: false
    }
  },
  getters: {
    getCurrentSubscriberGroup(state) {
      const actorStore = useActorStore()
      const currentActor: any | undefined = actorStore.getCurrentActor
      if (currentActor) {
        const subscriberGroupID = currentActor.subscriber_group
        const foundSG = state.subscriberGroups.find((sg) => sg.id === subscriberGroupID)
        return foundSG
      }
      return undefined
    }
  },
  actions: {
    async initialize() {
      return await Promise.all([this.retrieveSubscriberGroups()])
    },
    async retrieveSubscriptions() {
      const { axios } = await useAuthDependencies()()
      this.loading = true
      const response = await axios({
        method: 'get',
        url: '/api/subscribed_holders'
      })
      this.subscriptions = response.data.data
    },
    async retrieveSubscriberGroups() {
      const { axios } = await useAuthDependencies()()
      const response = await axios({
        method: 'get',
        url: '/api/subscriber_groups'
      })
      this.subscriberGroups = response.data.data
    }
  }
})
